import { apiFetch, buildApiError } from './httpClient';

export const financialService = {
  async _req(path, opts = {}) {
    const res = await apiFetch(`/api${path}`, {
      method: opts.method || 'GET',
      headers: { 'Content-Type': 'application/json', ...(opts.headers || {}) },
      body: opts.body ? JSON.stringify(opts.body) : undefined,
    });
    if (!res.ok) {
      throw await buildApiError(res, 'Financial profile request failed');
    }
    return res.json();
  },

  // Stage A
  async getProfile() {
    return this._req('/profile');
  },
  async upsertProfile(data) {
    return this._req('/profile', { method: 'POST', body: data });
  },

  // Generic CRUD helpers for Stage B
  async list(resource) { return this._req(`/${resource}`); },
  async create(resource, data) { return this._req(`/${resource}`, { method: 'POST', body: data }); },
  async patch(resource, id, data) { return this._req(`/${resource}/${id}`, { method: 'PATCH', body: data }); },
  async remove(resource, id) { return this._req(`/${resource}/${id}`, { method: 'DELETE' }); },
};
